import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import withSizes from 'react-sizes';
import Carousel from 'components/Carousel';
import CarouselContainer from 'components/Carousel/CarouselContainer';
import ClientExclusiveCard from './ClientExclusiveCard';

function ClientExclusive({ clientData, isMobile, isTablet, data }) {
  const responsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 961,
      },
      items: 3,
    },
    mobile: {
      breakpoint: {
        max: 600,
        min: 0,
      },
      items: 1,
      parpartialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: {
        max: 961,
        min: 600,
      },
      items: 2,
    },
  };
  let finalSlideToShow;
  if (isMobile) {
    finalSlideToShow = 1;
  } else if (isTablet) {
    finalSlideToShow = 2;
  } else {
    finalSlideToShow = 3;
  }
  if (_isEmpty(data)) return null;
  return (
    <CarouselContainer>
      <Carousel
        responsive={responsive}
        infinite={!!isMobile}
        slideToShow={finalSlideToShow}
      >
        {data.map((item, index) => {
          if (_get(item, 'reviewStatus') !== 'Accepted') return null;

          return (
            <ClientExclusiveCard
              item={item}
              key={index}
              clientData={clientData}
            />
          );
        })}
      </Carousel>
    </CarouselContainer>
  );
}

ClientExclusive.propTypes = {
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  clientData: PropTypes.object,
  data: PropTypes.array,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 600,
  isTablet: width <= 961 && width >= 600,
});
export default withSizes(mapSizesToProps)(ClientExclusive);
